import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {ToggleFacebookInstagramIsEnabled as ToggleFacebookInstagramIsEnabledMutation} from 'nutshell-graphql-types';

import TOGGLE_FACEBOOK_INSTAGRAM_IS_ENABLED from '../mutations/toggle-facebook-instagram-is-enabled.graphql';

export const useToggleFacebookInstagramIsEnabled = (): {
    toggleFacebookInstagramIsEnabled: () => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [toggleFacebookInstagramIsEnabled, {loading, error}] = useMutation<
        ToggleFacebookInstagramIsEnabledMutation,
        Record<any, any>
    >(TOGGLE_FACEBOOK_INSTAGRAM_IS_ENABLED);

    return {
        toggleFacebookInstagramIsEnabled: () => {
            return toggleFacebookInstagramIsEnabled();
        },
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
